




















import { Component, Vue } from 'vue-property-decorator';
import Header from '@/views/Header.vue';
import Footer from '@/views/Footer.vue';
import Navi from '@/components/NaviComponent.vue';

@Component({
    components: {
        'v-header': Header,
        'v-footer': Footer,
        'navi': Navi,
    },
})
export default class MainViews extends Vue {
    private drawer: boolean | null = false;

    private handleClose(drawer: boolean) {
        this.drawer = drawer;
    }
}
